import template from './signin.html';
import controller from './signin.controller';
import './signin.styl';
const SigninComponent = {
    template,
    controller,
    controllerAs: 'signin',
    require: {
        app: '^^app'
    }
};

export default SigninComponent;


/** WEBPACK FOOTER **
 ** ./frontend/components/auth/signin/signin.component.js
 **/